<header class="hero-header">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-6">
                <div class="hero-content">
                    <h1>Launch in Minutes!</h1>
                    <h4>Enterprise grade iOS & Android Apps</h4>
                    <button class="btn btn-lg btn-outline-dark btn-with-icon rounded-pill" (click)="scroll()">Get Started Now <mat-icon>trending_flat</mat-icon></button>
                </div>
            </div>
            <div class="col-lg-6">
                <div class="hero-img-container">
                    <img src="./assets/imgs/header-graphic.svg" alt="" class="img-fluid" loading="lazy">
                </div>
            </div>
        </div>
    </div>
</header>